"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsDetail = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const patient_kpi_1 = require("client/modules/patients/modules/patients-detail/components/patient-kpi");
const store_1 = require("client/modules/patients/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
require("./patients-detail.less");
const details_1 = require("./tabs/details");
const orders_1 = require("./tabs/orders");
let PatientsDetail = class PatientsDetail extends router_1.TabRouter {
    get name() {
        var _a;
        const patient = (_a = store_1.patientsStore.patient.value) !== null && _a !== void 0 ? _a : {
            firstName: "",
            lastName: ""
        };
        return [patient.firstName, patient.lastName].join(" ").trim();
    }
    constructor(props) {
        super(props);
        this.withPadding = true;
        // The second parameter is used to specify the default siteId when adding from tab list
        this.addTab("Details", () => `/patients/${Number(this.props.params[0])}`, /^\/patients\/(\d+)\/?(\d+)?$/, details_1.DetailsTab);
        {
            store_3.usersStore.permissions.ReadClaims &&
                this.addTab("Claims", () => `/patients/${Number(this.props.params[0])}/claims`, /^\/patients\/(\d+)\/claims$/, orders_1.OrdersTab);
        }
    }
    componentDidMount() {
        const patientId = Number(this.props.params[0]);
        if (patientId) {
            store_1.patientsStore.loadOrders({ id: patientId });
            store_1.patientsStore.readPatient(patientId);
            this.showTabs(true);
        }
        else {
            const siteId = this.props.params.length === 2 ? Number(this.props.params[1]) : 0;
            if (siteId) {
                store_2.sitesDetailStore.readSite(siteId);
            }
            this.showTabs(false);
        }
    }
    componentWillReceiveProps(props) {
        const oldPatientId = Number(this.props.params[0]);
        const newPatientId = Number(props.params[0]);
        if (newPatientId && oldPatientId !== newPatientId) {
            store_1.patientsStore.loadOrders({ id: newPatientId });
            store_1.patientsStore.readPatient(newPatientId);
        }
        if (newPatientId) {
            this.showTabs(true);
        }
        else {
            this.showTabs(false);
        }
    }
    render() {
        const patientId = Number(this.props.params[0]);
        const newPatientClass = patientId === 0 ? "new-patient-" : "";
        const patient = store_1.patientsStore.patient.value;
        const patientSites = patient &&
            !!patient.sites &&
            !!patient.sites.length &&
            patient.sites.map((site) => site.id);
        // D-017.21
        const numbers = patientId.toString().split(',');
        const paddedNumbers = numbers.map(num => {
            const number = parseInt(num, 10);
            return !isNaN(number) ? String(number).padStart(8, '0') : 'Invalid';
        });
        return (React.createElement("div", { className: "patient" }, store_3.usersStore.permissions.ReadPatients || // Can read any patient.
            (store_3.usersStore.permissions.ReadPatient &&
                patientSites &&
                patientSites.includes(store_3.usersStore.user.value.site.id)) || // This patient shares a site id.
            (store_3.usersStore.permissions.CreatePatient && !patientId) ? ( // We can make a new patient.
        React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false },
                React.createElement(patient_kpi_1.PatientKpi, { patientKpi: {
                        name: patientId === 0
                            ? "New Patient"
                            : React.createElement(React.Fragment, null,
                                capitalize_string_1.capitalizeString(this.name),
                                " ",
                                React.createElement("br", null),
                                " ",
                                React.createElement("div", { style: { fontSize: "medium", color: "#18c273", fontWeight: "400" } },
                                    "Patient ID - ",
                                    paddedNumbers[0])),
                        nextAppt: new Date(),
                        orders: (store_1.patientsStore.patient.value &&
                            store_1.patientsStore.patient.value.orders &&
                            store_1.patientsStore.patient.value.orders.length) ||
                            0,
                        total: 247.82
                    } })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: `patient__${newPatientClass}tabs` }, super.render())))) : (store_3.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.computed
], PatientsDetail.prototype, "name", null);
PatientsDetail = __decorate([
    mobx_react_1.observer
], PatientsDetail);
exports.PatientsDetail = PatientsDetail;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/patients-detail.tsx
// module id = 3799
// module chunks = 0